// extracted by mini-css-extract-plugin
export default {"lc-modal":"NavigationModal__lc-modal--lc-r5tBu","lc-overlay":"NavigationModal__lc-overlay--lc-_Yo2s","navigationOpen":"NavigationModal__navigationOpen--lc-uQPKn"};